/**
 * Created by user on 2020/7/1.
 */

import { join, normalize } from "path";

export default __dirname;
